import { useSnackbar } from 'notistack';
import { useState } from 'react';
import {
  IconButton, Dialog,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useApi } from 'lib/contexts/ApplicationState';
import { NetworkAccountFilter } from 'components/NetworkAccountFilter';
import { NetworkAccount } from 'lib/types/networkAccounts';

interface Props {
  onClose: () => void;
  postOwner?: NetworkAccount;
  postId: number;
  network: number;
}

export const PostOwnerModal = ({
  onClose, postOwner, postId, network,
}: Props) => {
  const API = useApi();
  const { enqueueSnackbar } = useSnackbar();
  const [owner, setOwner] = useState(postOwner);
  const [isSaving, setIsSaving] = useState(false);

  const onSave = async () => {
    if (!owner?.id) {
      enqueueSnackbar('Please select a post owner', { variant: 'error' });
      return;
    }

    try {
      setIsSaving(true);
      await API.updatePostOwner(postId, owner.id);
      enqueueSnackbar('Post owner updated', { variant: 'success' });
      onClose();
    } catch (err: any) {
      enqueueSnackbar(
        err?.message || 'Something went wrong updating post owner',
        { variant: 'error' },
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog fullWidth open aria-labelledby="form-dialog-title">
      <div className="p-6">
        <div className="absolute right-3 top-3">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        Update post owner
        <div className="my-4">
          <NetworkAccountFilter
            label="Post Owner"
            onChange={(_, value) => {
              if (!value) {
                setOwner(undefined);
                return;
              }
              if (Array.isArray(value)) {
                setOwner(value[0] as NetworkAccount);
                return;
              }
              setOwner(value as NetworkAccount);
            }}
            value={owner}
            networkId={network}
          />
        </div>
        <button
          type="button"
          className="btn-secondary"
          onClick={onSave}
          disabled={owner?.id === postOwner?.id || isSaving}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </Dialog>
  );
};
